import React from 'react';
import { Card } from 'ui-toolkit';
import '../../scss/_loan-details.scss';
import Currency from './Currency';
import { INavigateAwayHelper } from './NavigateAwayHelper';
import { ModalTriggerButton } from './Modals/ModalTriggerButton';
import { eSingleFields } from './context/state/eSingleFields';

export interface ILoanDetails {
  loanAmount: number | null;
  loanNumber?: string | null;
  ownerType: 'order' | 'quote';
  orderId: string;
  purchasePrice?: number | null;
  transactionType: 'purchase' | 'refinance';
  onNavigateAway: INavigateAwayHelper;
  hasEditPermissions?: boolean;
}

export default class LoanDetails extends React.Component<ILoanDetails> {
  public render() {
    const { loanAmount, loanNumber, ownerType, purchasePrice, transactionType, hasEditPermissions } = this.props;
    return (
      <Card title="Loan Details" className="loan-details" hasEditPermissions={hasEditPermissions}>
        <div className="loan-details__content">
          <div className="loan-details__amount">
            <div className="loan-details__label">Loan Amount</div>
            <div className="loan-details__amount-value">
              <ModalTriggerButton fieldName={eSingleFields.loan_amount} disabled={!hasEditPermissions}>
                {loanAmount ? <Currency value={loanAmount} /> : 'None'}
              </ModalTriggerButton>
            </div>
          </div>
          {transactionType === 'purchase' ? (
            <div className="loan-details__purchase-price">
              <div className="loan-details__label">Purchase Price</div>
              <div className="loan-details__purchase-price-value">
                <ModalTriggerButton fieldName={eSingleFields.purchase_price} disabled={!hasEditPermissions}>
                  {purchasePrice ? <Currency value={purchasePrice} /> : 'None'}
                </ModalTriggerButton>
              </div>
            </div>
          ) : null}
          {ownerType === 'order' ? (
            <div className="loan-details__number">
              <div className="loan-details__label">Loan Number</div>
              <div className="loan-details__number-value">
                <div>
                  <ModalTriggerButton fieldName={eSingleFields.loan_number} disabled={!hasEditPermissions}>
                    {loanNumber ? loanNumber : 'None'}
                  </ModalTriggerButton>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </Card>
    );
  }
}
